import React from 'react';
import { SHAPE } from '../interfaces';
export var WholeElementSelectionMode;
(function (WholeElementSelectionMode) {
    WholeElementSelectionMode["WHOLE_ONLY"] = "whole_only";
    WholeElementSelectionMode["INDIVIDUAL_SEATS"] = "individual_seats";
})(WholeElementSelectionMode || (WholeElementSelectionMode = {}));
export var VisualState;
(function (VisualState) {
    VisualState["NORMAL"] = "normal";
    VisualState["OCCUPIED"] = "occupied";
    VisualState["SELECTED"] = "selected";
})(VisualState || (VisualState = {}));
export const SeatingViewerContext = React.createContext(null);
//# sourceMappingURL=seating-viewer-context.js.map